function componentVideoHobby() {
  // if ($('.js-hobby-next').length) {
  //   var videoHobby = $('#video-hobby')[0]
  //   var isHobbyPlaying = false
  //   var timeOutHobby
  //   $('.js-hobby-next').on('click', function () {
  //     if (!isHobbyPlaying) {
  //       isHobbyPlaying = true
  //       videoHobby.play()
  //       timeOutHobby = setTimeout(() => {
  //         videoHobby.pause()
  //         isHobbyPlaying = false
  //         clearTimeout(timeOutHobby)
  //       }, 1000)
  //     }
  //   })
  // }

  if ($('.js-play-video').length) {
    var videoHobby = $('#video-hobby')[0]
    // var isHobbyPlaying = false
    var timeOutHobby
    $('.js-play-video').on('click', function () {
      videoHobby.play()
      $('.swiper-arrow__icon--play').removeClass('is-active')
      $('.swiper-arrow__icon--pause').addClass('is-active')
      // isHobbyPlaying = true

      timeOutHobby = setTimeout(() => {
        videoHobby.pause()
      }, 1500)

      timeOutHobby = setTimeout(() => {
        videoHobby.play()
      }, 3000)

      timeOutHobby = setTimeout(() => {
        videoHobby.pause()
      }, 4500)

      timeOutHobby = setTimeout(() => {
        videoHobby.play()
      }, 6000)

      timeOutHobby = setTimeout(() => {
        videoHobby.pause()
      }, 8000)

      timeOutHobby = setTimeout(() => {
        videoHobby.play()
      }, 9500)

      timeOutHobby = setTimeout(() => {
        videoHobby.pause()
        videoHobby.currentTime = 0
        $('.swiper-arrow__icon--play').addClass('is-active')
        $('.swiper-arrow__icon--pause').removeClass('is-active')
        clearTimeout(timeOutHobby)
      }, 11500)
    })

    $('.js-pause-video').on('click', function () {
      videoHobby.pause()
      $('.swiper-arrow__icon--play').addClass('is-active')
      $('.swiper-arrow__icon--pause').removeClass('is-active')
      clearTimeout(timeOutHobby)
      // isHobbyPlaying = true
      // timeOutHobby = setTimeout(() => {
      //   videoHobby.pause()
      //   isHobbyPlaying = false
      //   clearTimeout(timeOutHobby)
      // }, 1000)
    })
  }
}
